import Vue from "vue";
import {IModalState} from "~/interfaces/modalInterfaces";
import {ModalStatus} from "~/models/modalStatus"

export default Vue.extend({
  props: {
    state: Object as () => IModalState,
  },
  data() {
    return {
      ModalStatus,
    }
  },
});